export default __webpack_public_path__ + "static/media/r6.b183739d.jpg";